var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFoodCover = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 18,
  viewBox: "0 0 24 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M23.52 16.2h-.5c.01-.16.02-.318.02-.48A11.042 11.042 0 0 0 15.2 5.155c.1-.309.155-.63.16-.955a3.36 3.36 0 1 0-6.72 0c.006.326.06.65.163.96a11.052 11.052 0 0 0-7.574 8.16H13.92a.48.48 0 1 1 0 .96H1.065c-.067.477-.101.958-.105 1.44 0 .162.01.32.02.48h-.5a.48.48 0 1 0 0 .96h23.04a.48.48 0 1 0 0-.96ZM14.272 4.916a10.865 10.865 0 0 0-4.54.007A2.259 2.259 0 0 1 9.6 4.2a2.4 2.4 0 1 1 4.8 0 2.259 2.259 0 0 1-.128.716Z"
})));
export default SvgFoodCover;